module.exports = __webpack_public_path__ + "img/type3_uncheck1.ef521ae7.png";